export default __webpack_public_path__ + "static/media/1_14_logo.71d85683.png";